import React from "react";
import _ from "lodash";
import { EuiFlexItem } from "@elastic/eui";
import TripDetailsSection from "../TripDetailsSection";

export default function DriverDetails({
    label,
    driverOptions,
    supplierId,
    driverName,
    onChange,
    isEditable,
    onConfirmingField,
    isConfirmed,
}) {
    return (
        <EuiFlexItem>
            <TripDetailsSection
                label={label}
                options={{
                    ...driverOptions,
                    url: `${driverOptions.url}`,
                    filterResource: `filter[supplierId]=${supplierId}`,
                }}
                selectedValue={driverName}
                onSelectChange={onChange}
                isEditable={isEditable}
                type="dropdown"
                onConfirmingField={onConfirmingField}
                isConfirmed={isConfirmed}
            />
        </EuiFlexItem>
    );
}
